import React, {useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {Paper, Tabs, Tab, Grid, useMediaQuery} from '@material-ui/core';
import {Form} from './components';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import theme from 'theme';

function TabPanel(props) {
  const {isSmall,children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} style={isSmall?{padding:2}:{}}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  formContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(4),
  },
  listContainer: {
    height: '100%',
    marginTop: 20,
  },
  input: {
    marginTop: theme.spacing(4),
  },
  ReactCropContainer: {
    marginTop: theme.spacing(6),
    padding: theme.spacing(3),
    border: '3px dashed rgba(0,0,0,0.1)',
  },
  alertContainer: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(15),
    backgroundColor: theme.palette.primary.light + '1c',
    border: '2px solid ' + theme.palette.primary.dark,
    borderRadius: 4,
    '&  > *': {
      color: theme.palette.primary.dark,
    },
  },
  alertIcon: {
    margin: -8,
    marginLeft: theme.spacing(1),
  },
}));

const SendNotification = () => {
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'));

  const classes = useStyles();

  return (
    <React.Fragment>
      <Paper square className={classes.root}>
        <TabPanel isSmall={isSmall} style={{padding:10}}>
          <Grid item xs={12} sm={12}>
            {isSmall?
                          <Form />

          :
            <Paper className={classes.formContainer}>
              <Form />
            </Paper>
}
          </Grid>
        </TabPanel>
      </Paper>
    </React.Fragment>
  );
};

export default SendNotification;
